import Leads from "./LeadsContainer";
export { default as LeadsTable } from "./Leads";

export default Leads;
